var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-transaction-rupee",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-6h1a3 3 0 0 1 0 6h-1l3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5h8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5v8a3 3 0 0 0 3 3h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionRupee);
export default __webpack_public_path__ + "static/media/transaction-rupee.e91f2bdb4c1b61de0328f6b9337d743a.svg";
export { ForwardRef as ReactComponent };